import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsIataComponent } from './simple-icons-iata.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsIataComponent ],
    exports:      [ SimpleIconsIataComponent ],
    bootstrap:    []
})
export class SimpleIconsIataModule {}
